<script setup lang="ts">
import type { NavigationMenuTriggerProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { ChevronDown } from 'lucide-vue-next';
import { NavigationMenuTrigger, useForwardProps } from 'reka-ui';
import { navigationMenuTriggerStyle } from './navigation-menu';

const props = defineProps<NavigationMenuTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <NavigationMenuTrigger
    v-bind="forwardedProps"
    :class="cn(navigationMenuTriggerStyle(), 'group', props.class)"
  >
    <slot />

    <SvgoCommonArrowDown
      class="ml-1 transition duration-300 group-data-[state=open]:rotate-180"
      filled
      :font-controlled="false"
      aria-hidden="true"
    />
  </NavigationMenuTrigger>
</template>
